import React from "react";
import { ArrowRight, Gift } from "lucide-react";
import { useM } from "../useM";
import { Reveal, SectionHead, MkButton } from "../ui";

export const PricingTeaser = () => {
  const m = useM();
  return (
    <section className="border-t border-white/10 bg-mk-navy py-28 lg:py-40" data-testid="pricing-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHead eyebrow={m("pricing.eyebrow")} title={m("pricing.title")} />
        <div className="mt-16 grid gap-6 md:grid-cols-2">
          <Reveal className="rounded-2xl border border-white/10 bg-mk-bg p-8 lg:p-12" >
            <div data-testid="pricing-card-free">
              <Gift size={26} className="text-mk-yellow" />
              <h3 className="mt-8 font-heading text-3xl font-bold uppercase text-white">{m("pricing.freeT")}</h3>
              <p className="mt-4 text-sm leading-relaxed text-mk-muted md:text-base">{m("pricing.freeD")}</p>
            </div>
          </Reveal>
          <Reveal delay={0.1} className="relative overflow-hidden rounded-2xl border border-mk-yellow/40 bg-mk-bg p-8 lg:p-12">
            <div className="absolute -right-24 -top-24 h-64 w-64 rounded-full bg-mk-blue/25 blur-3xl" />
            <div className="relative" data-testid="pricing-card-pro">
              <p className="font-mono-t text-xs uppercase tracking-[0.2em] text-mk-yellow">{m("pricing.paidT")}</p>
              <p className="mt-6 flex items-baseline gap-3">
                <span className="font-heading text-6xl font-black text-white lg:text-7xl" data-testid="pricing-price">{m("pricing.price")}</span>
                <span className="text-sm text-mk-muted">{m("pricing.per")}</span>
              </p>
              <p className="mt-4 text-sm leading-relaxed text-mk-muted md:text-base">{m("pricing.paidD")}</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export const CtaBanner = () => {
  const m = useM();
  return (
    <section className="relative overflow-hidden px-6 py-32 lg:py-44" data-testid="cta-section">
      <img src="/media/hero-poster.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-b from-mk-bg via-mk-bg/70 to-mk-bg" />
      <Reveal className="relative mx-auto max-w-5xl text-center">
        <h2 className="font-heading text-4xl font-black uppercase leading-[0.92] text-white sm:text-6xl lg:text-7xl">
          {m("cta.title1")}<br /><span className="text-mk-yellow">{m("cta.title2")}</span>
        </h2>
        <MkButton to="/register" className="mt-12" data-testid="cta-get-started">{m("cta.btn")} <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" /></MkButton>
      </Reveal>
    </section>
  );
};
